import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetAdminApplicationRequestDto } from "../../../api/apiServices/backOffice/controllers/adminPanel/adminPanel.requestsDto";
import { GetApplicationByIdResponseDto } from "../../../api/apiServices/backOffice/controllers/applications/applications.requestsDto";
import { ApplicationModel } from "../../../viewModels/Applications/ApplicationModel";

type State = {
  request?: GetAdminApplicationRequestDto;
  application?: ApplicationModel;
  selectedRoute?: GetApplicationByIdResponseDto["selectedRoute"];
  borderCrossings: GetApplicationByIdResponseDto["borderCrossings"];
  loading: boolean;
  error: boolean;
  activeCalculationKey?: string;
};
const initialState: State = { loading: false, error: false, borderCrossings: [] };
const slice = createSlice({
  name: "adminPanelApplication",
  initialState,
  reducers: {
    loadApplication: (_state, action: PayloadAction<GetAdminApplicationRequestDto>) => ({
      ...initialState,
      request: action.payload,
      loading: true,
    }),
    loadApplicationSuccess(
      state,
      action: PayloadAction<{
        request: GetAdminApplicationRequestDto;
        application: ApplicationModel;
        selectedRoute?: State["selectedRoute"];
        borderCrossings: State["borderCrossings"];
      }>,
    ) {
      if (state.request?.id !== action.payload.request.id || state.request?.officeType !== action.payload.request.officeType) return;
      state.application = action.payload.application;
      state.selectedRoute = action.payload.selectedRoute;
      state.borderCrossings = action.payload.borderCrossings;
      state.activeCalculationKey = action.payload.application.calculations[0]?.uuid;
      state.loading = false;
    },
    loadApplicationReject(state, action: PayloadAction<GetAdminApplicationRequestDto>) {
      if (state.request?.id !== action.payload.id || state.request?.officeType !== action.payload.officeType) return;
      state.loading = false;
      state.error = true;
    },
    changeCalculation(state, action: PayloadAction<string | undefined>) {
      state.activeCalculationKey = action.payload;
    },
    resetState: () => initialState,
  },
});
export default slice;
